import { Cirus } from "@/classes/Http";
import { AxiosResponse } from "axios";
import { TimeScope } from "../Instance";
import { objectToQuery } from "../ObjectToQuery";

export function getUserMe() {
    return Cirus.get(`/me`, {});
}

export function getPrimary() {
    return Cirus.get(`/user/instance/primary`, {});
}

export function setPrimary(instance_id: number) {
    const query = `/user/instance/primary?instance_id=${instance_id}`;
    return Cirus.post(query, {}, {});
}

export class UserShop {
    id: number;
    name: string;
    username: string;
    accepted: number;
}

export class GetUserShopInstancesResponse {
    instances: UserShop[];
    count: number;
}

export function getInstances(params: string): Promise<AxiosResponse<GetUserShopInstancesResponse>> {
    const query = `/user/instances/?${params}`;
    return Cirus.get(query, {});
}

const scopeToDay  = {
    'day': 1,
    'week': 7,
    'month': 30,
    'year': 365
}

class getUserShopsTotalStatResponse{
    total_growth: string;
    total_sold: number;
    total_bought: number;
}
export function getUserShopsTotalStat(time_scope: TimeScope, time_scale: number): Promise<AxiosResponse<getUserShopsTotalStatResponse>> {
    const days = scopeToDay[time_scope]*time_scale;
    const query = `/user/shops/stats?days=${days}`;
    return Cirus.get(query, {});
}

export function getTayehInvoices() {
    const query = `/user/customer/invoices`;
    return Cirus.get(query, {});
}

enum TicketStatus {
    waiting_for_support='در انتظار پشتیبانی',
    support_answered='پاسخ پشتیبانی',
    user_answered='پاسخ کاربر',
    closed='بسته شده'
}

enum TicketStatusCode {
    waiting_for_support=0,
    support_answered=1,
    user_answered=2,
    closed=3
}

class SupportTicket {
    id: number;
    title: string;
    category: string;
    status: TicketStatus;
    status_code: TicketStatusCode;
    dateUpdated: Date;
}

export class GetUserSupportTicketsResponse {
    count: number;
    tickets: SupportTicket[];
}

export function getUserSupportTickets(page = 0, search = ''): Promise<AxiosResponse<GetUserSupportTicketsResponse>> {
    const query = `/support/tickets?${objectToQuery({page, search})}`;
    return Cirus.get(query);
}

export function deleteUserSupportTicket(id: number): Promise<AxiosResponse<GetUserSupportTicketsResponse>> {
    const query = `/support/ticket/${id}`;
    return Cirus.delete(query);
}

export class GetUserSupportTicketCategoryResponse {
    id: number;
    name: string;
}

export function getUserSupportTicketCategories(): Promise<AxiosResponse<GetUserSupportTicketCategoryResponse[]>> {
    const query = '/support/categories';
    return Cirus.get(query);
}

export class CreateUserSupportTicketBody {
    title: string;
    category_id: number;
    message: string;
    instance?: number;
}

export function createUserSupportTicket(body: CreateUserSupportTicketBody) {
    const query = '/support/ticket';
    return Cirus.put(query, body);
}

export * from './Query/'
export * from './Command/'